export default "__VITE_ASSET__Cfq7gJGB__"